import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Hide the Emergent badge
const hideEmergentBadge = () => {
  const allDivs = document.querySelectorAll('body > div, body > a');
  allDivs.forEach(el => {
    if (el.id === 'root') return;
    const text = el.textContent || '';
    const href = el.href || el.querySelector?.('a')?.href || '';
    if (text.includes('Emergent') || href.includes('emergent')) {
      el.style.display = 'none';
    }
  });
};
setTimeout(hideEmergentBadge, 1000);
setTimeout(hideEmergentBadge, 3000);
setTimeout(hideEmergentBadge, 5000);
new MutationObserver(hideEmergentBadge).observe(document.body, { childList: true });
